import { call, put } from 'redux-saga/effects'
import { client as axios } from '@src/api/clients/axios'
import URI from 'urijs'
import { notification } from 'antd'
import config from 'config'
import actions from '../actions'

export function* contactUsStart(values) {
	const uri = new URI(`${config.api}/0/contact-us`)
	const apiUri = uri.toString()

	const postData = data =>
		axios
			.post(apiUri, data, {
				withCredentials: true,
				validateStatus: status => (status >= 200 && status < 300) || status === 429,
			})
			.then(res => {
				if (res.status === 429) {
					notification.error({
						message: 'Ochrana proti útokom',
						description:
							'Snažíme sa ochrániť údaje užívateľov. Z toho dôvodu sme zablokovali vašu IP adresu na 30 minút.',
					})

					throw res
				} else {
					return res
				}
			})
			.catch(err => {
				throw err
			})

	try {
		const response = yield call(postData, values.payload)
		yield put(actions.contactUsSuccess(response))
	} catch (err) {
		yield put(actions.contactUsError())
	}
}

export function* contactUsSuccess() {
	const showNotification = () => {
		notification.success({
			message: 'Upozornenie',
			description: 'Zaslanie správy prebehlo úspešne.',
		})
	}
	yield call(showNotification)
}
